var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgReloadTime = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9988 7.12H11.2188L13.9588 4.3C11.2288 1.6 6.80878 1.5 4.07878 4.2C1.34878 6.91 1.34878 11.28 4.07878 14C6.80878 16.7 11.2288 16.7 13.9588 14C15.3188 12.65 15.9988 11.08 15.9988 9.1H17.9988C17.9988 11.08 17.1188 13.65 15.3588 15.39C11.8488 18.87 6.14878 18.87 2.63878 15.39C-0.861217 11.92 -0.891217 6.28 2.61878 2.81C6.12878 -0.66 11.7588 -0.66 15.2688 2.81L17.9988 0V7.12ZM9.49878 5V9.25L12.9988 11.33L12.2788 12.54L7.99878 10V5H9.49878Z",
    fill: "#595959"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReloadTime, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reload-time.00085387.svg";
export { ForwardRef as ReactComponent };